import loadingSlice from '@gagovictor/shared-frontend-core/dist/shared/redux/loadingSlice';
import preferencesSlice, {
    PreferencesState,
} from '@gagovictor/shared-frontend-core/dist/shared/redux/preferencesSlice';
import { combineSlices, configureStore } from '@reduxjs/toolkit';

import tomatoSlice, {
    saveTomatoState,
    TomatoState,
} from './tomato/tomatoSlice';

// No auth, account or purchase slices: this app has no accounts. Shared core pieces used are preferences (theme) and loading.
export const rootReducer = combineSlices(
    loadingSlice,
    preferencesSlice,
    tomatoSlice
);

export type RootState = {
    loading: ReturnType<typeof loadingSlice.reducer>;
    preferences: PreferencesState;
    tomato: TomatoState;
};

export function setupStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: rootReducer,
        preloadedState: preloadedState as never,
    });
}

export type AppDispatch = typeof store.dispatch;

const store = setupStore();

let lastSaved: TomatoState | undefined;
store.subscribe(() => {
    const next = store.getState().tomato;
    if (next !== lastSaved) {
        lastSaved = next;
        saveTomatoState(next);
    }
});

export default store;
